import { Button, Row } from "antd";
import { useCallback } from "react";

type FooterProps = {
  isLoading: boolean;
  onChangeIsOpen: (value: boolean) => void;
  onExport: () => void;
};

export const Footer = ({
  isLoading,
  onChangeIsOpen,
  onExport,
}: FooterProps) => {
  const onClose = useCallback(
    (): void => onChangeIsOpen(false),

    [onChangeIsOpen]
  );

  return (
    <Row className="justify-end mt-6 mb-1">
      <Button
        type="primary"
        shape="round"
        loading={isLoading}
        disabled={isLoading}
        onClick={onExport}
      >
        Export
      </Button>
      <Button
        shape="round"
        className="ml-2"
        disabled={isLoading}
        onClick={onClose}
      >
        Cancel
      </Button>
    </Row>
  );
};
